'use strict';

var base = require('../product/base');
var focusHelper = require('../components/focus');
const cartHelper = require('./cartHelper');
const { showToastMessage } = require('../components/toast');
const { getTranslation } = require('../common/jsTranslations');
const QR = require('../thirdParty/qr');

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $('.card.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '<button type="button" class="btn-close" data-bs-dismiss="modal"></button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#editProductModal .enter-message').text(data.enterDialogMessage);
            $('#editProductModal').modal('show');
            $('body').trigger('editproductmodal:ready');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Display add-to-cart confirmation alert based on URL Param.
 * Used for add-to-cart when triggered from cart page
 * After display Param is removed from URL to avoid display again after page refresh
 */
function showAddToCartConfirmationAlert() {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    if (params.get('addtocart') === 'success') {
        showToastMessage({
            message: getTranslation('text.alert.addedtobasket'),
            alertType: 'alert-success'
        });

        params.delete('addtocart');
        window.history.replaceState({}, document.title, url.toString());
    }
}

$('#js-copy-link-btn').bind('click', () => {
    const $shareLinkInput = $('#js-share-link-input');
    $shareLinkInput.select();
    const msg = $shareLinkInput.data('msg');
    document.execCommand('copy');

    $('#shareLinkModal').modal('hide');
    if (msg) {
        showToastMessage({
            message: msg,
            alertType: 'alert-success'
        });
    }
});

$('#js-copy-bbcode-btn').bind('click', () => {
    const $shareCodeInput = $('#js-share-bbcode-input');
    $shareCodeInput.select();
    const msg = $shareCodeInput.data('msg');
    document.execCommand('copy');

    $('#shareBBCodeModal').modal('hide');
    if (msg) {
        showToastMessage({
            message: msg,
            alertType: 'alert-success'
        });
    }
});

module.exports = function () {
    $('body').on('click', '#js-cart-shareLinkModalBtn', function () {
        var shareUrl = $(this).data('url');
        if (!shareUrl) {
            return;
        }

        $.ajax({
            url: shareUrl,
            type: 'post',
            success: function (data) {
                if (data?.copyUrl) {
                    const $shareLinkInput = $('#js-share-link-input');
                    $shareLinkInput.val(data.copyUrl);
                    $shareLinkInput.data('msg', data.msg);
                    $('#shareLinkModal').modal('show');
                }
            },
            error: function (err) {
                console.error(err);
            }
        });
    });

    $('body').on('click', '#js-cart-shareBBCodeModalBtn', function () {
        var shareUrl = $(this).data('url');
        if (!shareUrl) {
            return;
        }

        $.ajax({
            url: shareUrl,
            type: 'post',
            success: function (data) {
                if (data?.copyCode) {
                    // adapt
                    const $shareCodeInput = $('#js-share-bbcode-input');
                    $shareCodeInput.val(data.copyCode);
                    $shareCodeInput.data('msg', data.msg);
                    $('#shareBBCodeModal').modal('show');
                }
            },
            error: function (err) {
                console.error(err);
            }
        });
    });

    $('body').on('click', '#js-cart-shareQRCodeBtn', function () {
        var shareUrl = $(this).data('url');
        if (!shareUrl) {
            return;
        }

        $.ajax({
            url: shareUrl,
            type: 'post',
            success: function (data) {
                if (data && data.copyUrl) {
                    var container = document.getElementById('js-qrcode-container');
                    if (!container) {
                        return;
                    }
                    try {
                        container.innerHTML = QR.toSVG(QR.encode(data.copyUrl, { ecc: 'M' }), { margin: 4, size: 300 });
                        container.querySelector('svg').classList.add('w-100', 'h-auto');
                        $('#shareQRCodeModal').modal('show');
                    } catch (error) {
                        console.error(error);
                    }
                }
            },
            error: function (error) {
                console.error(error);
            }
        });
    });

    $('body').on('click', '.js-remove-all-products-confirmation-btn', function () {
        var actionUrl = $(this).data('action');
        if (!actionUrl) {
            return;
        }

        $.ajax({
            url: actionUrl,
            type: 'post',
            success: function (data) {
                if (typeof window.checkResponseForEventDetails === 'function') {
                    window.checkResponseForEventDetails(data);
                }
                if (data.success) {
                    if ('scrollRestoration' in window.history) {
                        window.history.scrollRestoration = 'manual';
                    }
                    window.location.reload();
                } else {
                    showToastMessage({
                        message: data.msg,
                        alertType: 'alert-error'
                    });
                }
            },
            error: function (err) {
                console.error(err);
                showToastMessage({
                    message: getTranslation('error.message.general.reach.customer.support'),
                    alertType: 'alert-error'
                });
            }
        });
    });

    $('.js-promo-code-form').submit(function (e) {
        e.preventDefault();
        var $form = $(this);

        $.spinner().start();
        $form.find('.form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');
        var cartItemsCountBeforeCoupon = $form.data('cart-items-count');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $form.find('.form-control').addClass('is-invalid');
                    $form.find('.form-control').attr('aria-describedby', 'invalidCouponCode');
                    $('.coupon-error-message').empty().append(data.errorMessage);
                    $('body').trigger('promotion:error', data);
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    cartHelper.updateCartTotals(data);
                    cartHelper.updateApproachingDiscounts(data.approachingDiscounts);
                    cartHelper.validateBasket(data);
                    $('body').trigger('promotion:success', data);
                    $('#braintree-cart-button-wrapper').addClass('d-none');
                    if (data.items.length !== cartItemsCountBeforeCoupon) {
                        window.location.reload();
                    }
                }
                $('.coupon-code-field').val('');
                $.spinner().stop();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    cartHelper.createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var promotionsNames = $(this).data('promotions');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(promotionsNames);
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var cartItemsCountBeforeCoupon = $('.js-promo-code-form').data('cart-items-count');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = cartHelper.appendToUrl(url, urlParams);

        $('body > .modal-backdrop')?.remove();

        $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                cartHelper.updateCartTotals(data);
                cartHelper.updateApproachingDiscounts(data.approachingDiscounts);
                cartHelper.validateBasket(data);
                $.spinner().stop();
                $('body').trigger('promotion:success', data);
                $('#braintree-cart-button-wrapper').removeClass('d-none');
                if (data.items.length !== cartItemsCountBeforeCoupon) {
                    window.location.reload();
                }
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    cartHelper.createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('change', '.bonus-product-checkbox', function () {
        const $checkbox = $(this);
        const uuid = $checkbox.data('uuid');
        const pliuuid = $checkbox.data('pliuuid');
        $.spinner().start();
        if ($checkbox.prop('checked')) {
            const pid = $checkbox.data('pid');
            const pidObject = {
                bonusProducts: [
                    {
                        pid: pid,
                        qty: 1,
                        options: []
                    }
                ],
                totalQty: 1
            };
            const addUrl = $checkbox.data('actionAdd');
            const pidString = JSON.stringify(pidObject);
            const queryString = '?pids=' + pidString + '&uuid=' + uuid + '&pliuuid=' + pliuuid;
            const actionUrl = addUrl + queryString;
            $.ajax({
                url: actionUrl,
                method: 'POST',
                success: function (data) {
                    if (data.error) {
                        if (data.errorMessage) {
                            showToastMessage({
                                message: data.errorMessage,
                                alertType: 'alert-danger'
                            });
                        }
                        $.spinner().stop();
                    } else {
                        window.location.reload();
                    }
                },
                error: function () {
                    showToastMessage({
                        message: getTranslation('error.message.general.reach.customer.support'),
                        alertType: 'alert-danger',
                        disableAutoClosing: true,
                        disableCloseButton: false
                    });
                    $.spinner().stop();
                }
            });
        } else {
            const removeUrl = $checkbox.data('actionDelete');
            $.ajax({
                url: removeUrl + '?pliuuid=' + pliuuid,
                method: 'POST',
                success: function (data) {
                    if (data.error) {
                        if (data.errorMessage) {
                            showToastMessage({
                                message: data.errorMessage,
                                alertType: 'alert-danger'
                            });
                        }
                        $.spinner().stop();
                    } else {
                        window.location.reload();
                    }
                },
                error: function () {
                    showToastMessage({
                        message: getTranslation('error.message.general.reach.customer.support'),
                        alertType: 'alert-danger',
                        disableAutoClosing: true,
                        disableCloseButton: false
                    });
                    $.spinner().stop();
                }
            });
        }
    });

    $('body').on('hidden.bs.modal', '#choose-bonus-product-modal', function () {
        $('#choose-bonus-product-modal').modal('hide');
        $('#choose-bonus-product-modal').remove();

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
        e.preventDefault();

        var editProductUrl = $(this).attr('href');
        getModalHtmlElement();
        fillModalElement(editProductUrl);
    });

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        $('.update-cart-product-global', dialog).attr(
            'disabled',
            !$('.global-availability', dialog).data('ready-to-order')
            || !$('.global-availability', dialog).data('available')
        );
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);

        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) {
                    return $(item).data('available');
                });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) {
                    return $(item).data('ready-to-order');
                });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
        }
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this).children('option:selected').data('value-id');
        $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
    });

    $('body').on('change', '.js-options-radio', function () {
        var selectedOptionValueId = $(this).data('value-id');
        $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
        var selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
        var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId
        };

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $('#editProductModal').modal('hide');

                    $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
                    cartHelper.updateCartTotals(data.cartModel);
                    cartHelper.updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    cartHelper.updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    cartHelper.validateBasket(data.cartModel);

                    $('body').trigger('cart:update', data);
                    document.body.dispatchEvent(new CustomEvent('cartUpdate', { detail: data, bubbles: true }));

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        cartHelper.createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    showAddToCartConfirmationAlert();
    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
};
